<template>
  <div>
    <div>
      <div class="vx-row justify-end mb-4">
        <div class="vx-col">
          <vs-button
            @click="onClickUpload"
          >
            アップロード
          </vs-button>
        </div>
      </div>
      <v-expansion-panels v-model="openingPanel">
        <v-expansion-panel value="panel1">
          <v-expansion-panel-title class="bg-white border-transparent">
            レポート一覧
            <template v-slot:actions="{expanded}">
              <VueFeather
                :type="expanded ? 'chevron-up' : 'chevron-down' "
                class="feather-icon feather-icon-css-target inline-flex"
              />
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <data-table
              :column-defs="columnDefs"
              :default-col-def="defaultColDef"
              :row-data="ecUserAnalysis"
              :grid-options="gridOptions"
              pagination
            />
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
      <AmcEcUserAnalysisForm
        v-model="showForm"
        title="CSVアップロード"
        submitButtonText1="テーブルに追加"
        submitButtonText2="テーブルを上書き"
        @change-append="onFileInputChangeAppend"
        @change-overwrite="onFileInputChangeOverwrite"
      />
      <vs-popup
        v-model:active="popupUploadComplete"
        title="CSVアップロード"
      >
        <p
          class="mb-4 mt-5"
          v-html="popupMessage"
        />
      </vs-popup>
    </div>

    <div class="vx-row justify-end mt-8">
      <div class="vx-col">
        <DateRanges
          :start-day="startDay"
          :end-day="endDay"
          @on-change="onDateChange"
        />
      </div>
    </div>
    <div class="vx-row justify-end mt-4">
      <div class="vx-col">
        <switch-field
          v-model="innerFiltered"
          class="mb-4"
          name="フィルター表示"
          label="フィルター表示"
        />
      </div>
    </div>
    <div
      v-if="showFilters"
      class="vx-row justify-end"
    >
      <div
        style="z-index: 9998;"
        class="vx-col"
      >
        <div class="filter">
          <sales-filter
            v-model="selectedBrand"
            class="w-48 mb-1 mr-1"
            :options="brandOptions"
            no-option-text="候補がありません"
            placeholder="ブランド"
          />
        </div>
      </div>
    </div>

    <div class="vx-row px-4 mt-4">
      <vx-card>
        <div class="vx-row mx-1">
          <div>
            売上
          </div>
          <div class="vx-row ml-auto">
            <div class="vx-col w-64">
              <select-field
                v-model="categoryNo"
                name="カテゴリー"
                :options="optionCategoryNo"
                :allow-empty="false"
                full-width
              />
            </div>
            <div class="vx-col">
              <vs-button
                @click="onClickDownload('sales')"
                class="px-4 pt-2 pb-1"
                :disabled="!canAccessSalesReport"
              >
              <VueFeather
                type="download"
                size="1.25rem"
              />
              </vs-button>
            </div>
          </div>
        </div>
        <div style="height: 400px">
          <div v-if="canAccessSalesReport">
            <amc-ec-user-analysis-sales-chart
              :class="{'min-h-full': !reportData}"
              :report="reportData.sales"
              :height="400"
              :category-no="categoryNo"
            />
          </div>
          <p v-else class="h-full flex align-center justify-center">
            No Data
          </p>
        </div>
      </vx-card>

      <vx-card class="mt-4">
        <div class="vx-row mx-1">
          <div>
            ページビュー
          </div>
          <div class="vx-row ml-auto">
            <div class="vx-col w-64">
              <select-field
                v-model="categoryNo"
                name="カテゴリー"
                :options="optionCategoryNo"
                :allow-empty="false"
                full-width
              />
            </div>
            <div class="vx-col">
              <vs-button
                @click="onClickDownload('pageViews')"
                class="px-4 pt-2 pb-1"
                :disabled="!canAccessPageViewsReport"
              >
              <VueFeather
                type="download"
                size="1.25rem"
              />
              </vs-button>
            </div>
          </div>
        </div>
        <div style="height: 400px">
          <div v-if="canAccessPageViewsReport">
            <amc-ec-user-analysis-page-views-chart
              :class="{'min-h-full': !reportData}"
              :report="reportData.pageViews"
              :height="400"
              :category-no="categoryNo"
            />
          </div>
          <p v-else class="h-full flex align-center justify-center">
            No Data
          </p>
        </div>
      </vx-card>

    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import DataTable from '@/components/table/DataTable'
import SalesFilter from '@/components/SalesFilter'
import DateRanges from '@/components/DateRanges'
import SwitchField from '@/components/fields/SwitchField'
import SelectField from '@/components/fields/SelectField'
import AmcEcUserAnalysisForm from '@/components/forms/AmcEcUserAnalysisForm'
import AmcEcUserAnalysisSalesChart from '@/user/components/charts/AmcEcUserAnalysisSalesChart'
import AmcEcUserAnalysisPageViewsChart from '@/user/components/charts/AmcEcUserAnalysisPageViewsChart'

export default {
  name: 'EcUserAnalysis',
  components: {
    DataTable,
    SalesFilter,
    DateRanges,
    SwitchField,
    SelectField,
    AmcEcUserAnalysisForm,
    AmcEcUserAnalysisSalesChart,
    AmcEcUserAnalysisPageViewsChart
  },
  data () {
    return {
      openingPanel: [],
      defaultColDef: {
        sortable: false,
        editable: false,
        resizable: false,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ステータス',
          field: 'status',
          cellRenderer: this.statusRenderer
        },
        {
          headerName: 'ファイル名',
          field: 'originalName'
        },
        {
          headerName: 'レコード数',
          field: 'recordsProvided'
        },
        {
          headerName: 'マッチID数',
          field: 'recordsWithRecognizedIdentity'
        },
        {
          headerName: 'マッチ率',
          field: 'rate',
          valueFormatter (params) {
            return params.value ? `${params.value}％` : ''
          }
        },
        {
          headerName: 'アップロード日',
          field: 'createdAt'
        }
      ],
      gridOptions: {},
      showForm: false,
      popupUploadComplete: false,
      popupMessage: '',
      categoryNo: 1,
      // フィルター
      selectedBrand: [],
      filtered: false,
      showFilters: false,
    }
  },
  computed: {
    ...mapState(['startDay', 'endDay']),
    ...mapState('amcEcUserAnalysis', ['ecUserAnalysis', 'reportData']),
    optionCategoryNo () {
      const category = [
        { text:'カテゴリー1', value: 1},
        { text:'カテゴリー2', value: 2},
        { text:'カテゴリー3', value: 3},
        { text:'カテゴリー4', value: 4},
        { text:'カテゴリー5', value: 5}
      ]
      return category
    },
    brandOptions () {
      if (!this.reportData) {
        return []
      }
      return this.reportData.salesByBrand.map(item => ({
        text: item.brand,
        value: item.brand,
        sales: item.sales
      }))
    },
    selectedBrandValues () {
      return this.selectedBrand.map(selectedBrand => selectedBrand.value)
    },
    innerFiltered: {
      get () {
        return this.filtered
      },
      set (val) {
        this.filtered = val
        this.showFilters = val
      }
    },
    // chart.jsのchartDataを動的に生成するとき、エラー回避のためにv-ifで制御が必要
    canAccessSalesReport () {
      return this.reportData.sales.flat().length > 0
    },
    canAccessPageViewsReport () {
      return this.reportData.pageViews.flat().length > 0
    },
  },
  watch: {
    selectedBrand: {
      handler () {
        this.fetchReports()
      },
      deep: true
    },
  },
  async created () {
    this.gridOptions = {
      autoSizeStrategy: {
        type: 'fitGridWidth'
      }
    }
    // 初期期間は11ヶ月前一日~前日
    this.$store.commit('SET_STARTDAY', moment().startOf('month').subtract(11, 'month').format('YYYY-MM-DD'))
    this.$store.commit('SET_ENDDAY',  moment().subtract(1, 'days').format('YYYY-MM-DD'))
    await Promise.all([
      this.fetchEcUserAnalysis(),
      this.fetchBrand()
    ])
    await this.fetchReports()
  },
  methods: {
    ...mapActions('amcEcUserAnalysis', ['fetchEcUserAnalysis', 'uploadEcUserAnalysis', 'fetchBrand', 'fetchSalesReports', 'fetchPageViewReports', 'downloadCSV']),
    statusRenderer (params) {
      switch (params.value) {
        case 1:
        case 2:
        case 3:
          return 'processing'
        case 4:
          return 'success'
        case 9:
          return 'error'
        default:
          return ''
      }
    },
    async onClickUpload () {
      this.showForm = true
    },
    async onFileInputChangeAppend (event) {
      const files = event.target.files || event.dataTransfer.files
      if (files.length > 0) {
        const data = {
          file: files[0],
          overwrite: false
        }
        try {
          this.showForm = false
          const res = await this.uploadEcUserAnalysis(data)
          this.popupMessage = (res.data.success) ? `アップロードが完了しました。` : `アップロードが失敗しました。${res.data.message}`
          this.openingPanel = ['panel1']
          await this.fetchEcUserAnalysis()
        } catch (e) {
          console.log(e)
          this.popupMessage = `ファイルサイズは130MB以下にしてください [${e.message}]`
        } finally {
          this.popupUploadComplete = true
        }
      }
    },
    async onFileInputChangeOverwrite (event) {
      const files = event.target.files || event.dataTransfer.files
      if (files.length > 0) {
        const data = {
          file: files[0],
          overwrite: true
        }
        try {
          this.showForm = false
          const res = await this.uploadEcUserAnalysis(data)
          this.popupMessage = (res.data.success) ? `アップロードが完了しました。` : `アップロードが失敗しました。${res.data.message}`
          this.openingPanel = ['panel1']
          await this.fetchEcUserAnalysis()
        } catch (e) {
          console.log(e)
          this.popupMessage = `ファイルサイズは130MB以下にしてください [${e.message}]`
        } finally {
          this.popupUploadComplete = true
        }
      }
    },
    async onClickDownload (action) {
      try {
        await this.downloadCSV({action, ...this.generateParams()})
      } catch (e) {
        console.log(e)
      }
    },
    onDateChange (date) {
      this.$store.commit('SET_STARTDAY', moment(date.start).format())
      this.$store.commit('SET_ENDDAY',  moment(date.end).format())
      this.fetchReports()
    },
    generateParams () {
      const params = {}
      params['start_day'] = this.startDay.split('T')[0]
      params['end_day'] = this.endDay.split('T')[0]
      if (this.selectedBrandValues) {
        params['brand'] = this.selectedBrandValues
      }
      return params
    },
    async fetchReports () {
      const params = this.generateParams()
      await Promise.all[
        this.fetchSalesReports(params),
        this.fetchPageViewReports(params)
      ]
    }
  }
}
</script>
